<template>
    <div class="bank-account-verification">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <form @submit.prevent="submit" accept-charset="UTF-8" novalidate="novalidate">
                    <fieldset>
                        <header>
                            <h4>Verify Bank Account</h4>
                        </header>

                        <p>
                            Two small deposits have been sent to this bank account. To verify this account, please
                            confirm the amounts of these deposits.
                        </p>

                        <div class="row">
                            <div class="col-sm-6 form-group has-feedback"
                                 :class="{'has-error': errors.has('amount_1')}">
                                <label for="amount-1">Amount 1</label>

                                <div class="input-group">
                                    <span class="input-group-addon padding-sm-right">$ 0.</span>

                                    <input id="amount-1"
                                           maxlength="2"
                                           minlength="1"
                                           v-validate="'required|between:1,99'"
                                           v-model="amount_1"
                                           name="amount_1"
                                           type="text"
                                           class="form-control"
                                           aria-required="true">
                                </div>

                                <span v-show="errors.has('amount_1')" class="help-block">
                                    {{ errors.first('amount_1') }}
                                </span>
                            </div>

                            <div class="col-sm-6 form-group has-feedback"
                                 :class="{'has-error': errors.has('amount_2')}">
                                <label for="amount-2">Amount 2</label>

                                <div class="input-group">
                                    <span class="input-group-addon padding-sm-right">$ 0.</span>

                                    <input id="amount-2"
                                           maxlength="2"
                                           minlength="1"
                                           v-validate="'required|between:1,99'"
                                           v-model="amount_2"
                                           name="amount_2"
                                           type="text"
                                           class="form-control"
                                           aria-required="true">
                                </div>

                                <span v-show="errors.has('amount_2')" class="help-block">
                                    {{ errors.first('amount_2') }}
                                </span>
                            </div>
                        </div>

                        <hr>

                        <div class="row">
                            <div class="col-xs-6 form-group pull-right">
                                <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                    Save
                                </button>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: {
            modalId: {
                default(){
                    return _.uniqueId( 'modal_' );
                },
                type: String
            },

            sourceId: {
                type: String,
                required: true
            }
        },

        data(){
            return {
                amount_1: null,
                amount_2: null,
                loading: false
            };
        },

        computed: {
            importForm(){
                var form = document.createElement( 'form' );
                form.setAttribute( 'method', 'POST' );
                form.setAttribute( 'action', '/stripeCustomer/sources/' + this.sourceId + '/verify' );

                var hiddenField = document.createElement( 'input' );
                hiddenField.setAttribute( 'type', 'hidden' );
                hiddenField.setAttribute( 'name', '_method' );
                hiddenField.setAttribute( 'value', 'PUT' );

                var token = $( 'meta[name="csrf-token"]' ).attr( 'content' );
                var tokenField = document.createElement( 'input' );
                tokenField.setAttribute( 'type', 'hidden' );
                tokenField.setAttribute( 'name', '_token' );
                tokenField.setAttribute( 'value', token );

                var amount1 = document.createElement( 'input' );
                amount1.setAttribute( 'type', 'hidden' );
                amount1.setAttribute( 'name', 'Source[amount_1]' );
                amount1.setAttribute( 'value', this.amount_1 );
                form.appendChild( amount1 );

                var amount2 = document.createElement( 'input' );
                amount2.setAttribute( 'type', 'hidden' );
                amount2.setAttribute( 'name', 'Source[amount_2]' );
                amount2.setAttribute( 'value', this.amount_2 );
                form.appendChild( amount2 );

                form.appendChild( tokenField );
                form.appendChild( hiddenField );

                return form;
            },
        },

        methods: {
            submit(){
                return this.$validator.validateAll()
                    .then( ( valid ) => {
                        if( valid ){
                            this.loading = true;

                            const form = this.importForm;

                            document.body.appendChild( form );
                            form.submit();
                        }
                    } );
            },

            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            },
        }
    };
</script>
